/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react';
import styled from '../../styles/styled';
import Button from '../../Button';
import getOverrides from '../../overrides/helper';
import { getBottomLineStyles, getStyles, getLabelStyles, getTextStyles, getPreTextStyles, getSuffixTextStyles, getContainerStyles, getSupportiveTextStyles, getIcon, getPlaceholderStyle, getHoverStyle, getInputContainerMargin, } from './helpers';
import { VARIANT, STATE } from '../constants';
const Label = styled.span `
  ${(props) => {
    const { theme, state, variant, disabled, } = props;
    const style = getLabelStyles({
        variant,
        state,
        theme,
        disabled,
    });
    return Object.assign({}, style);
}}

`;
// const Label = styled.div`
//   margin-bottom: 4px;
//   ${(props) => {
//     const {
//       theme,
//     } = props;
//     const style = getTitleStyles({ theme });
//     return {
//       ...style,
//     };
//   }}
// `;
const Root = styled.div `
  position: relative;
  margin: 0;
  border: none;
  text-decoration: none;
  overflow: hidden;
  display: flex;
    ${(props) => {
    const { theme, state, variant, disabled, } = props;
    const style = getStyles({
        theme,
        state,
        variant,
        disabled,
    });
    return Object.assign({}, style);
}}
  button {
    ${(props) => {
    const { variant, } = props;
    const style = {
        margin: (variant === VARIANT.compact) ? ('8px 12px 8px 0') : ('12px 12px 12px 0'),
    };
    return Object.assign({}, style);
}}
    background-color: transparent;
    padding-left: 0;
    padding-right: 0;
    flex: none;
    @media (hover: hover) {
      &:hover::before {
        content: none;
      }
    }
  }
  &:focus {
    box-shadow: 0 0 0 2px   ${({ theme }) => theme.colors.info};
  }
  @media (hover: hover) {
    &:hover {
    background: ${(props) => {
    const { state, theme, disabled, } = props;
    return getHoverStyle({ state, theme, disabled });
}};
      button {
        background: none;
      }
    }
  }
  ${({ $style }) => $style};
};

 
`;
const BottomLine = styled.span `
  position: absolute;
  bottom: 0;
  width: 100%;
  ${(props) => {
    const { theme, state, disabled, } = props;
    const style = getBottomLineStyles({ state, theme, disabled });
    return Object.assign({}, style);
}}

`;
const Container = styled.div `
  position: relative;
  width: 100%;
  ${(props) => {
    const { theme, icon, variant, } = props;
    const margin = getInputContainerMargin({ variant, theme });
    const style = getContainerStyles({ icon, theme });
    return Object.assign({ margin }, style);
}}
`;
const Input = styled.input `
  flex: auto;
  overflow: hidden;
  ${(props) => {
    const { theme, state, prefixText, disabled, } = props;
    const style = getTextStyles({
        prefixText,
        state,
        theme,
        disabled,
    });
    return Object.assign({}, style);
}}
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: ${({ theme }) => theme.spacing.spacing0};
  }
  ::placeholder {
    ${(props) => {
    const { theme, } = props;
    const style = getPlaceholderStyle({ theme });
    return Object.assign({}, style);
}}
  }
`;
const PrefixText = styled.span `
  ${(props) => {
    const { theme, state, disabled, } = props;
    const style = getPreTextStyles({ state, theme, disabled });
    return Object.assign({}, style);
}}
`;
const SuffixText = styled.span `
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  ${(props) => {
    const { theme, state, disabled, } = props;
    const style = getSuffixTextStyles({ state, theme, disabled });
    return Object.assign({}, style);
}}
`;
const Icon = styled.div `
  ${(props) => {
    const { variant, } = props;
    const style = {
        margin: (variant === VARIANT.compact) ? ('8px 12px') : ('12px'),
    };
    return Object.assign({}, style);
}}
`;
const TrailingIcon = styled.div `
  ${(props) => {
    const { variant, } = props;
    const style = {
        margin: (variant === VARIANT.compact) ? ('8px 12px 8px') : ('14px 16.5px 14px'),
    };
    return Object.assign({}, style);
}}
`;
const InputPrefix = styled.div `
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
`;
const SupportiveContainer = styled.div `
  height: 20px;
  padding-top: ${({ theme }) => theme.spacing.spacing20};
  position: relative;
  svg {
    position: absolute;
    right: 0;
  }
  ${(props) => {
    const { theme, state, disabled, } = props;
    const style = getSupportiveTextStyles({ state, theme, disabled });
    return Object.assign({}, style);
}}
`;
const LabelWrapper = styled.div `
  height: 16px;
  margin-bottom: 4px;
  margin-left: 2px;
`;
const CompactContainer = styled.div ``;
const Component = (props) => {
    const { value, state: propState, placeholder, onChange, onBlur, onFocus, overrides, } = props;
    const [focused, setFocused] = useState(false);
    const [inputText, setInputText] = useState(value || '');
    const inputRef = useRef(null);
    const handleChange = (e) => {
        setInputText(e.target.value);
        if (onChange && typeof onChange === 'function') {
            onChange(e);
        }
    };
    const handleBlur = (e) => {
        setFocused(false);
        if (onBlur && typeof onBlur === 'function') {
            onBlur(e);
        }
    };
    const handleFocus = (e) => {
        setFocused(true);
        if (onFocus && typeof onFocus === 'function') {
            onFocus(e);
        }
    };
    const customProps = Object.assign(Object.assign({}, props), { state: focused ? STATE.focus : propState });
    delete customProps.onChange;
    const { label, icon, leadingIconAction = () => { }, prefixText, suffixText, trailingIcon, trailingIconAction, inlineAction, inlineActionText, supportiveText, disabled, state, variant, type, } = customProps;
    useEffect(() => {
        if (value !== inputText) {
            setInputText(value || '');
        }
    }, [value]);
    useEffect(() => {
        if (state === 'focus' && inputRef) {
            inputRef.current.focus();
            setFocused(true);
        }
    }, [state]);
    const RootOverride = getOverrides('Root', overrides);
    const getComponent = () => (React.createElement(React.Fragment, null,
        React.createElement(Root, Object.assign({}, customProps, RootOverride),
            icon && React.createElement(Icon, { variant: variant, onClick: leadingIconAction }, icon),
            React.createElement(Container, Object.assign({}, customProps, { onClick: () => setFocused(true), onFocus: (e) => handleFocus(e), onBlur: (e) => handleBlur(e) }),
                React.createElement(InputPrefix, null,
                    prefixText && (focused || inputText)
                        && React.createElement(PrefixText, { disabled: disabled }, prefixText),
                    React.createElement(Input, Object.assign({ ref: inputRef, type: type || 'text' }, customProps, { onChange: (e) => handleChange(e), value: inputText, placeholder: ((focused || (variant === VARIANT.compact)) ? (!value && placeholder) : '') })),
                    suffixText
                        && (!trailingIcon && !inlineActionText)
                        && (focused || inputText) && React.createElement(SuffixText, { disabled: disabled }, suffixText)),
                (variant !== VARIANT.compact)
                    && (React.createElement(Label, { state: ((focused || inputText) ? STATE.focus : STATE.default), disabled: disabled }, label))),
            (!inlineActionText && trailingIcon)
                && (React.createElement(TrailingIcon, { variant: variant, onClick: trailingIconAction }, trailingIcon)),
            inlineActionText && inlineAction && (React.createElement(Button, { kind: "tertiary", size: "medium", shape: "default", onClick: inlineAction, disabled: !inputText }, inlineActionText)),
            React.createElement(BottomLine, { state: ((focused && (state !== STATE.error)) ? STATE.focus : state), disabled: disabled })),
        supportiveText && (React.createElement(SupportiveContainer, Object.assign({}, customProps),
            supportiveText,
            (!disabled) && getIcon(state)))));
    if (variant === VARIANT.compact) {
        return (React.createElement(CompactContainer, null,
            label && (React.createElement(LabelWrapper, null,
                React.createElement(Label, { state: ((focused || inputText) ? STATE.focus : STATE.default), variant: variant }, label))),
            getComponent()));
    }
    return getComponent();
};
export default Component;
